
import { SubCategory } from '@/colors/componentCategories'
import Vue from 'vue';
import store from '../store';
import SubCategoryComponent from './SubCategoryComponent.vue';

export default Vue.extend({
  name: 'ConfiguratorCategoryContainer',
  store,
  components: {
    SubCategoryComponent,
  },
  props: {
    name: String,
    subcategory: {
      required: true,
      type: Array as () => SubCategory[]
    },
  },
  data() {
    return {
      uuid: Math.random().toString().slice(2)
    };
  },
});
